// extracted by mini-css-extract-plugin
module.exports = {"uploadBox":"UploadPhoto_uploadBox__3YaLh","uploadInput":"UploadPhoto_uploadInput__2fWbX","update-btn":"UploadPhoto_update-btn__3lLFr","avatar":"UploadPhoto_avatar__3alHL"};